"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _reResizable = require("re-resizable");
var _Layout = require("@mulesoft/exchange-ui-components/lib/components/Layout");
var _portals = require("@mulesoft/exchange-ui-portals-store/lib/domains/portals");
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _reactRedux = require("react-redux");
var _AssetMetadata = _interopRequireDefault(require("../AssetMetadata"));
var _DraftHeader = _interopRequireDefault(require("../DraftHeader"));
var _EditDocumentation = _interopRequireDefault(require("../EditDocumentation"));
var _Search = _interopRequireDefault(require("../Search"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles = {
  "layout-container": "AssetPortalsLayout__layout-container__3hRQm",
  "layoutContainer": "AssetPortalsLayout__layout-container__3hRQm",
  "sidebar": "AssetPortalsLayout__sidebar__1DF6V",
  "header-sidebar": "AssetPortalsLayout__header-sidebar__2fg0O",
  "headerSidebar": "AssetPortalsLayout__header-sidebar__2fg0O",
  "main-content": "AssetPortalsLayout__main-content__1RWHL",
  "mainContent": "AssetPortalsLayout__main-content__1RWHL"
}; 
require('./AssetPortalsLayout.css');
var DEFAULT_SIDEBAR_WIDTH = 250;
var RESIZABLE_STYLE = {
  width: DEFAULT_SIDEBAR_WIDTH,
  height: 'auto'
};
var ENABLE_RIGHT = {
  right: true
};
var AssetPortalsLayout = function AssetPortalsLayout(_ref) {
  var renderSidebar = _ref.renderSidebar,
    renderRoutes = _ref.renderRoutes,
    asset = _ref.asset,
    isPageComponent = _ref.isPageComponent;
  var isDraft = (0, _exchangeReactHooks.useIsPortalDraft)();
  var _React$useState = _react.default.useState(DEFAULT_SIDEBAR_WIDTH),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    sidebarWidth = _React$useState2[0],
    setSidebarWidth = _React$useState2[1];
  var hasUnpublishedChanges = (0, _reactRedux.useSelector)(function (state) {
    return _portals.selectors.hasUnpublishedChanges(state, _objectSpread(_objectSpread({}, asset), {}, {
      isDraft: isDraft
    }));
  });
  var isPortalSearchEnabled = (0, _exchangeReactHooks.useFeatureFlag)('portal-search-enabled');
  var routesStyle = _react.default.useMemo(function () {
    return {
      maxWidth: "calc(100vw - ".concat(sidebarWidth, "px)")
    };
  }, [sidebarWidth]);
  var handleResize = _react.default.useCallback(function () {
    for (var _len = arguments.length, _ref2 = new Array(_len), _key = 0; _key < _len; _key++) {
      _ref2[_key] = arguments[_key];
    }
    var sidebar = _ref2[2];
    return setSidebarWidth(sidebar.clientWidth);
  }, [setSidebarWidth]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !isDraft && isPortalSearchEnabled ? /*#__PURE__*/_react.default.createElement(_Search.default, {
    asset: asset
  }) : null, /*#__PURE__*/_react.default.createElement(_AssetMetadata.default, {
    asset: asset
  }), /*#__PURE__*/_react.default.createElement(_DraftHeader.default, {
    isPageComponent: isPageComponent,
    hasUnpublishedChanges: hasUnpublishedChanges
  }), /*#__PURE__*/_react.default.createElement(_Layout.Layout, {
    className: styles.layoutContainer
  }, /*#__PURE__*/_react.default.createElement(_reResizable.Resizable, {
    defaultSize: RESIZABLE_STYLE,
    minWidth: 200,
    maxWidth: 400,
    className: styles.sidebar,
    enable: ENABLE_RIGHT,
    onResize: handleResize
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: "sidebar",
    "data-test-id": "sidebar"
  }, renderSidebar())), /*#__PURE__*/_react.default.createElement("div", {
    className: styles.mainContent,
    style: routesStyle
  }, /*#__PURE__*/_react.default.createElement(_EditDocumentation.default, {
    isPageComponent: isPageComponent,
    hasUnpublishedChanges: hasUnpublishedChanges
  }), renderRoutes())));
};
var _default = exports.default = AssetPortalsLayout;
//# sourceMappingURL=AssetPortalsLayout.js.map